import api from './api';

const BASE = '/data-warehouse';

// ── Symbols ──────────────────────────────────────────────────────
export const searchSymbols = (q) =>
  api.get(`${BASE}/search/`, { params: { q } });

export const listSymbols = (params = {}) =>
  api.get(`${BASE}/symbols/`, { params });

export const getSymbolDetail = (symbol) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/`);

// ── Prices ───────────────────────────────────────────────────────
export const getSymbolPrices = (symbol, params = {}) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/prices/`, { params });

export const getSymbolChart = (symbol, params = {}) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/chart/`, { params });

// ── Screener ─────────────────────────────────────────────────────
export const runScreener = (body) =>
  api.post(`${BASE}/screener/`, body);

export const getScreenerFields = () =>
  api.get(`${BASE}/screener/fields/`);

// ── Fundamentals ─────────────────────────────────────────────────
export const getCompanyProfile = (symbol) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/profile/`);

export const getFinancials = (symbol, params = {}) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/financials/`, { params });

export const getDividends = (symbol) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/dividends/`);

export const getEarnings = (symbol) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/earnings/`);

// ── Relationships ────────────────────────────────────────────────
export const getRelationships = (symbol) =>
  api.get(`${BASE}/symbols/${encodeURIComponent(symbol)}/relationships/`);
